export default "__VITE_ASSET__VEx7s7LT__"